import React, { useState, useEffect } from 'react';
import '../CSS/HeroBanner.css';
import { Link } from 'react-router-dom';
import DateConvert from '../Utlis/DateConverter';

const HeroBanner = () => {
  const [newsData, setNewsData] = useState([]);
  const [currentNews, setCurrentNews] = useState(0);

  useEffect(() => {
    // Fetch news data from your API sorted by date and limit to 4 articles
    const fetchNewsData = async () => {
      const apiUrl = process.env.REACT_APP_BW_API_Url || process.env.REACT_APP_BW_LocalAPI_Url;
      try {
        const response = await fetch(`${apiUrl}/api/v1/posts/latestPost/`);
        if (!response.ok) {
          throw new Error('Failed to fetch news data');
        }
        const data = await response.json();
        setNewsData(data); // Assuming your API response is an array of news articles
      } catch (error) {
        console.error('Error fetching news data:', error);
      }
    };

    fetchNewsData();
  }, []);

  useEffect(() => {
    if (newsData.length > 0) {
      const timer = setInterval(() => {
        setCurrentNews((prevNews) => (prevNews + 1) % newsData.length);
      }, 5000);

      return () => {
        clearInterval(timer);
      };
    }
  }, [newsData]);

  return (
    <div className="hero-banner">
      {newsData.length > 0 && (
        <div className="hero-content">
          <div className="HeroImageWrapper">
            <img className="HeroImage" src={newsData[currentNews]?.thumbnailUrl} alt={newsData[currentNews]?.title} />
          </div>
          <div className="news-details">
            <p className='NewsInfo'>{newsData[currentNews]?.author} | {DateConvert(newsData[currentNews]?.createdAt)} | {newsData[currentNews]?.Sector}</p>
            <h1 className="newsTitle">{newsData[currentNews]?.title}</h1>
            <Link to={`/BlogPage/${newsData[currentNews]?._id}`} className="read-more">Read More</Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeroBanner;
